import React from 'react';

import { Container } from './styles';

export default function NavigationButtons({
    labelBackButton,
    onClickBackButton,
    hideBackButton,
    hideNextButton,
    labelNextButton,
    onClickNextButton,
    disabledBackButton,
    disabledNextButton,
    onClickChangePasswordButton,
    hideChangePasswordButton = true,
    disabledChangePasswordButton = true
}) {
    
    return (
        <Container hideBackButton={hideBackButton || hideNextButton} hideChangePasswordButton={hideChangePasswordButton} >
            {!hideChangePasswordButton &&
                <button
                    onClick={() => onClickChangePasswordButton()}
                    type="button"
                    className="btn"
                    disabled={disabledChangePasswordButton}
                >
                    Solicitar alteração de senha
                </button>
            }

        	{!hideBackButton &&
                <button 
                    type="button"
                    className="btn"
                    disabled={disabledBackButton}
                    onClick={() => onClickBackButton()}
                >
                    {labelBackButton}
                </button>
            }
        	
        	{!hideNextButton &&
                <button
                    type="submit"
                    id="nextButton"
                    onClick={() => onClickNextButton()}
                    disabled={disabledNextButton}
                    className="btn btn-default"
                >
                    {labelNextButton}
                </button>
            }
        </Container>
    )
}